module.exports = __webpack_public_path__ + "img/02.42d28cda.jpg";